import { render, staticRenderFns } from "./SingleDescrRowDoc.vue?vue&type=template&id=397cbcb4"
import script from "./SingleDescrRowDoc.vue?vue&type=script&lang=js"
export * from "./SingleDescrRowDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports